import { useTranslation } from 'react-i18next';
import { PostModal, PostModalProps } from '../shared';
import { Template, TemplateProps, TemplatePostDetailsType } from './template';

export type InfluencerFacebookAnalyticsPostDetailsModalProps = Pick<TemplateProps, 'isAnalytics'> &
  Pick<PostModalProps<TemplatePostDetailsType>, 'posts'>;

export const InfluencerFacebookAnalyticsPostDetailsModal = ({
  posts,
  ...templateProps
}: InfluencerFacebookAnalyticsPostDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={posts}>
      <PostModal.Title>{t('Post Detail')}</PostModal.Title>
      <Template {...templateProps} />
    </PostModal>
  );
};
